/*
 * Lemonade Training Oy, copy rights, all right reserved.
 *
 * The renewal-notice copy deck. Shared in substance with the push and email a
 * member already received 30 days out, and string for string with the mobile
 * card, so the same person reads the same words wherever they look. No em
 * dashes anywhere here.
 */

export const RENEWAL_ROLL_TITLE = (date: string) => `Your commitment ends on ${date}`;

/** `price` arrives already formatted, symbol included. */
export const RENEWAL_ROLL_BODY = (name: string, price: string, date: string) =>
  `After that, ${name} continues month to month at ${price} per month. ` +
  `Nothing to do if you want to keep going. If you would rather stop, you can set it to end on ${date}.`;

export const RENEWAL_ROLL_BODY_NO_PRICE = (name: string, date: string) =>
  `After that, ${name} continues month to month at your gym's standard monthly price. ` +
  `Nothing to do if you want to keep going. If you would rather stop, you can set it to end on ${date}.`;

export const RENEWAL_EXPIRE_TITLE = (date: string) => `Your membership ends on ${date}`;

export const RENEWAL_EXPIRE_BODY = (name: string, date: string) =>
  `Your ${name} commitment ends on ${date} and will not renew.`;

export const RENEWAL_KEEP_GOING = "Keep going";

export const RENEWAL_NOT_NOW = "Not now";

export const RENEWAL_CANCEL_AT_END = "Cancel at end date";

export const RENEWAL_RENEW = "Renew";

export const RENEWAL_KEEP_GOING_DONE_TITLE = "Nothing more to do.";

export const RENEWAL_KEEP_GOING_DONE = (date: string) => `Your membership continues after ${date}.`;

export const RENEWAL_KEEP_GOING_DONE_NO_DATE =
  "Your membership continues after your commitment ends.";
